module.exports = __webpack_public_path__ + "static/img/ParisGamesMap.5c633e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ParisGamesMap.svg
// module id = ije6
// module chunks = 0